(ns core.front.redirect-notification)

(def allowed-notification-titles
  #{:warning/session-expired :error/sso-failed-title :error/mfa-failed-title})

(def allowed-notification-captions
  #{:warning/session-expired-description :error/sso-failed-text :error/mfa-failed-text
    :error/oidc-invalid-redirect :error/oidc-no-cookie :error/oidc-invalid-state
    :error/oidc-email-not-verified :error/oidc-sub-changed :error/oidc-invalid-user})

;; The one success notice, allowed only as this exact tuple: Cloudpermit's RP-initiated
;; logout lands on the login page with it.
(def signed-out [:toast :success :signed-out/title :signed-out/description])

(def ^:private tuple-pattern
  ;; Only the supported EDN subset: four keyword tokens and an optional fixed string.
  ;; Full-input matching excludes nested values, comments, reader macros and trailing forms.
  (re-pattern (str "[\\s,]*\\[[\\s,]*:([a-z/-]+)[\\s,]+:([a-z/-]+)"
                   "[\\s,]+:([a-z/-]+)[\\s,]+:([a-z/-]+)"
                   "(?:[\\s,]+\"(notification#session-expired)\")?[\\s,]*\\][\\s,]*")))

(defn parse-allowed
  "Parse an already URL-decoded notification, or return nil. Limit input to 512 characters
   before parsing (existing producer tuples are under 150). This restricts displayable
   content, not the context in which an approved notice can appear."
  [input]
  (when (and (string? input) (<= (count input) 512))
    (when-let [[_ type kind title caption id] (re-matches tuple-pattern input)]
      (let [type    (keyword type)
            kind    (keyword kind)
            title   (keyword title)
            caption (keyword caption)]
        (cond
          (and (not id) (= signed-out [type kind title caption]))
          signed-out

          (and (= :toast type)
               (#{:warning :error} kind)
               (allowed-notification-titles title)
               (allowed-notification-captions caption))
          (if id
            (when (= [:toast :warning :warning/session-expired :warning/session-expired-description]
                     [type kind title caption])
              [type kind title caption "notification#session-expired"])
            [type kind title caption]))))))
